<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <span>{{ full_name }}</span>
      <img :src="user_picture" class="img-avatar" alt="fibernode.com" />
      <b-badge
        v-if="itemsCount > 0"
        style="margin-left: 35px"
        pill
        variant="danger"
        >{{ itemsCount }}</b-badge
      >
    </template>
    <template slot="dropdown">
      <b-dropdown-item to="/base/ProfileSettings">
        <i class="fa fa-user" /> Profile Settings
      </b-dropdown-item>
      <b-dropdown-item to="/base/Inbox">
        <i class="fa fa-envelope-o" /> Inbox
        <b-badge v-if="itemsCount > 0" variant="success">{{
          itemsCount
        }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item @click="logout()">
        <i class="fa fa-lock" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import router from "../../router";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    router,
    AppHeaderDropdown
  },
  data: () => {
    return {
      full_name: "",
      itemsCount: 0,
      user_picture: "",
      locationParam: null
    };
  },
  methods: {
    getCount() {
      let params = {};
      params = {};
      this.$http
        .get("api/inbox/getCount.php", {
          params
        })
        .then(
          res => {
            if (res.data.records && res.data.records.length > 0)
              this.itemsCount = res.data.records[0].count;
          },
          err => {
            console.log(err);
          }
        );
    },
    logout() {
      localStorage.clear();
      router.push("/pages/login/");
    }
  },
  mounted() {
    this.user_picture = localStorage.getItem("user_picture");

    this.locationParam = localStorage.getItem("user");
    this.full_name = localStorage.getItem("full_name");

    this.getCount();
  }
};
</script>
